export default __webpack_public_path__ + "static/PNS_PHOTOGRAPHY_3-3069ae7ca6933cd2b47484e2369aa2fa.jpg";